"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsMessagePayload = exports.isStatusMessagePayload = exports.isJobMessagePayload = exports.unMarshallMessageInput = exports.isMessagePayload = exports.isMessageInput = void 0;
const utils_1 = require("./utils");
const _1 = require("./");
const assert_1 = __importDefault(require("assert"));
function isMessageInput(arg) {
    return ((0, _1.isObject)(arg) &&
        "jobId" in arg &&
        typeof arg.jobId === "string" &&
        "inputFiles" in arg &&
        Array.isArray(arg.inputFiles) &&
        "modelPreset" in arg &&
        (arg.modelPreset === "monomer" || arg.modelPreset === "multimer") &&
        "dbPreset" in arg &&
        (arg.dbPreset === "full_dbs" || arg.dbPreset === "reduced_dbs") &&
        "maxTemplateDate" in arg &&
        typeof arg.maxTemplateDate === "string" &&
        "numMultimerPredictions" in arg &&
        typeof arg.numMultimerPredictions === "string" &&
        !isNaN(parseInt(arg.numMultimerPredictions)));
}
exports.isMessageInput = isMessageInput;
function isMessagePayload(arg) {
    return ((0, _1.isObject)(arg) &&
        "job_id" in arg &&
        typeof arg.job_id === "string" &&
        "input_files" in arg &&
        Array.isArray(arg.input_files) &&
        "model_preset" in arg &&
        (arg.model_preset === "monomer" || arg.model_preset === "multimer") &&
        "db_preset" in arg &&
        (arg.db_preset === "full_dbs" || arg.db_preset === "reduced_dbs") &&
        "max_template_date" in arg &&
        typeof arg.max_template_date === "string" &&
        "num_multimer_predictions" in arg &&
        typeof arg.num_multimer_predictions === "string" &&
        !isNaN(parseInt(arg.num_multimer_predictions)));
}
exports.isMessagePayload = isMessagePayload;
function unMarshallMessageInput(payload) {
    const messagePayload = (0, utils_1.convertAttributeNames)(payload, utils_1.camelToSnake);
    (0, assert_1.default)(isMessagePayload(messagePayload));
    return messagePayload;
}
exports.unMarshallMessageInput = unMarshallMessageInput;
function isJobMessagePayload(arg) {
    return ((0, _1.isObject)(arg) &&
        "job_id" in arg &&
        typeof arg.job_id === "string" &&
        "timestamp" in arg &&
        typeof arg.timestamp === "string");
}
exports.isJobMessagePayload = isJobMessagePayload;
function isStatusMessagePayload(arg) {
    return ((0, _1.isObject)(arg) &&
        "job_id" in arg &&
        typeof arg.job_id === "string" &&
        "timestamp" in arg &&
        "status" in arg &&
        typeof arg.status === "string");
}
exports.isStatusMessagePayload = isStatusMessagePayload;
function isResultsMessagePayload(arg) {
    return ((0, _1.isObject)(arg) &&
        "job_id" in arg &&
        typeof arg.job_id === "string" &&
        "timestamp" in arg &&
        "result_path" in arg &&
        typeof arg.result_path === "string");
}
exports.isResultsMessagePayload = isResultsMessagePayload;
